export default __webpack_public_path__ + "static/media/priority2.cd70199f.png";